import SiteFooter from "./SiteFooter";
import { PageTransition } from "@/components/ui-enhanced/PageTransition";

/**
 * PublicLayout — shared chrome for public marketing/legal/content pages.
 *
 * NOTE: the top navigation/header for every public route is provided by
 * `LayoutWrapper` (GuestNav sidebar + GuestHeader top bar). This component
 * therefore only supplies the page footer and the standard fade-in entry so
 * we don't double up on headers. If a page needs its own full-bleed hero
 * (e.g. About), it can render SiteFooter directly instead of using this.
 */
export default function PublicLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <div className="flex min-h-screen flex-col bg-background text-foreground noise-texture">
      <main className="flex-1">
        <PageTransition>{children}</PageTransition>
      </main>
      <SiteFooter />
    </div>
  );
}
